//src/pages/diaryjournal/MyJournal.jsx
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faHandsHelping, faUser, faUserGroup, faUsers } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// import journalhomeimage from '../../assets/pageimages/JournalHome.png';
import './DiaryJournal.css';
import { logout } from "../../redux/actions/authActions";
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

const MyJournalHome = () => {
    const navigate = useNavigate();
    const authState = useSelector(state => state.authReducer);

    const isLoggedIn = authState?.isLoggedIn || false;
    const userName = authState?.user?.name || "User";

    const dispatch = useDispatch();

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleLogout = () => {
        dispatch(logout());
        navigate("/sheearns");
    };

    const [selectedDate, setSelectedDate] = useState(new Date());

    useEffect(() => {
        document.title = isLoggedIn ? `${userName}'s dashboard` : "Think5Whys";
    }, [isLoggedIn, userName]);

    useEffect(() => {
        setSelectedDate(new Date());
    }, []);

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handleDateSubmit = () => {
        if (selectedDate) {
            navigate(`/journal/${selectedDate.toISOString().split('T')[0]}`);
        } else {
            alert('Please select a date before submitting.');
        }
    };

    const journalLinks = [
        { path: "/myjournal/1", icon: faUser, label: "Reflections of Me" },
        { path: "/myjournal/2", icon: faBriefcase, label: "Work Chronicle" },
        { path: "/myjournal/3", icon: faUsers, label: "Social Scribe" },
        { path: "/myjournal/4", icon: faHandsHelping, label: "Helper's Heaven" }
    ];

    return (
        <div className="min-h-screen flex flex-col bg-black text-blue-100 font-sans">
            <header className="sticky top-0 z-50 bg-black border-b border-blue-800 px-4 py-2 flex items-center justify-between shadow-lg">
                <div className="flex flex-col">
                    <h1 className="text-start text-yellow-200 text-sm lg:text-lg font-bold">
                        Journal@Think5Whys
                    </h1>
                </div>

                <div className="hidden md:flex items-center gap-3">
                    {isLoggedIn ? (
                        <>
                            <div className="text-xs text-left text-blue-300">{userName}</div>
                            <button
                                onClick={handleLogout}
                                className="p-2 mt-2 rounded-md bg-blue-600 hover:bg-blue-700 transition"
                                title="Logout"
                            >
                                ⏻
                            </button>
                        </>
                    ) : (
                        <>
                            <button
                                onClick={() => navigate("/login")}
                                className="px-3 py-1 rounded-full border border-blue-700 text-sm text-blue-200 hover:bg-blue-900"
                            >
                                Login
                            </button>
                            <button
                                onClick={() => navigate("/signup")}
                                className="px-3 py-1 rounded-full bg-blue-500 text-white text-sm hover:bg-blue-400"
                            >
                                Register
                            </button>
                        </>
                    )}
                </div>

                <button
                    onClick={() => setIsMobileMenuOpen((s) => !s)}
                    className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-blue-300 bg-blue-500"
                    aria-label="Toggle menu"
                >
                    {isMobileMenuOpen ? "×" : "☰"}
                </button>
            </header>

            {/* Mobile menu content */}
            {isMobileMenuOpen && (
                <div className="md:hidden bg-[#2a0f2f] border-b border-blue-800 px-4 py-2 animate-fadeIn">
                    {isLoggedIn ? (
                        <div className="flex flex-row items-center justify-center gap-3">
                            <span className="text-blue-300 font-medium whitespace-nowrap h-7">
                                Welcome, {userName}
                            </span>
                            <button
                                onClick={handleLogout}
                                className="rounded-md bg-blue-600 hover:bg-blue-700 w-7 h-7 flex items-center justify-center text-white"
                                title="Logout"
                            >
                                ⏻
                            </button>
                        </div>
                    ) : (
                        <div className="flex flex-row items-center justify-center gap-6">
                            <Link to="/login" className="text-blue-300 hover:text-yellow-300">
                                Login
                            </Link>
                            <span className="text-blue-500">|</span>
                            <Link to="/signup" className="text-blue-300 hover:text-yellow-300">
                                Register
                            </Link>
                        </div>
                    )}
                </div>
            )}

            <main className="flex-1 flex flex-col items-center justify-center px-4 py-8 gap-6">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 w-full">
                    {journalLinks.map((journal, index) => (
                        <Link
                        key={index}
                        to={journal.path}
                        className="
                            flex flex-col items-center justify-center 
                            w-full h-28               /* <-- SAME HEIGHT FOR ALL */
                            bg-black border border-green-300 
                            text-white hover:bg-green-700 
                            font-semibold rounded-lg text-sm p-4
                        "
                        >
                        <FontAwesomeIcon icon={journal.icon} className="mb-2 text-lg" />
                        <span className="text-center">{journal.label}</span>
                        </Link>
                    ))}
                </div>                

                <div className="flex flex-col items-center gap-4 w-full max-w-md">
                    <div className="flex items-center gap-2 bg-gray-100 px-3 py-2 rounded-lg">
                        <FontAwesomeIcon icon={faCalendarAlt} className="text-gray-500" />
                        <DatePicker
                            selected={selectedDate}
                            onChange={handleDateChange}
                            dateFormat="dd-MM-yyyy"
                            className="bg-transparent text-black focus:outline-none text-sm"
                            placeholderText="Select Date"
                        />
                    </div>
                    <button
                        onClick={handleDateSubmit}
                        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                    >
                        View Journal for Selected Date
                    </button>
                </div>
            </main>

            <footer className="bg-black border-t border-blue-800 text-blue-300 py-4 mt-auto">
                <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
                    <div className="text-xs lg:text-sm">
                        © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
                    </div>
                    <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
                        <Link to="/about-us" className="text-white hover:text-blue-400">About</Link>
                        <Link to="/privacy-policy" className="text-white hover:text-blue-400">Privacy Policy</Link>
                        <Link to="/terms-of-use" className="text-white hover:text-blue-400">Terms of Use</Link>
                        <Link to="/contact-us" className="text-white hover:text-blue-400">Contact</Link>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default MyJournalHome